import React, { useState, useEffect, useRef } from 'react';
// import Swiper from "swiper";

import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, Lazy, Autoplay, EffectFade } from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import './competitionSlider.css';
import 'swiper/swiper.scss';
import 'swiper/swiper-bundle.css';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/pagination/pagination.scss';
import 'swiper/components/scrollbar/scrollbar.scss';
import {
  Button,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardMedia,
  createStyles,
  Grid,
  IconButton,
  makeStyles,
  Theme,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import { useQuery } from '@apollo/client';
import { GET_WEBTOONS } from '../../../quries/webtoon';
import { Link } from 'react-router-dom';
import { GET_CITIZEN_IMAGES, GET_CITIZEN_MENU } from '../../../quries/citizenJoy';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

// install Swiper components
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay, EffectFade]);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    totalSector: {
      marginTop: '8%',
      display: 'flex',
      fontFamliy: 'Noto Sans KR',
    },
    leftDivSector: { paddingRight: '6rem' },
    imgSec: {
      // position: "relative",
      width: '100%',
    },

    aspectRatioBox: {
      //   height: 0,
      overflow: 'hidden',
      //   paddingTop: "calc(591.44px / 1127.34px * 100%)",
      //   paddingTop: "100%",
      // paddingTop: "56.25%",
      paddingTop: '42%',

      //   position: "relative",
    },

    aspectRatioBoxInside: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
    },
    fireboxCentering: {
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },

    viewPortSizing: {
      fontSize: '5vw',
    },
    cardRoot: {
      maxWidth: '100%',
      height: '100%',
    },
    media: {
      height: '85%',
    },
  }),
);

interface AspectDivVideoProps {
  children: React.ReactNode;
}

function AspectDivVideo(props: AspectDivVideoProps) {
  const classes = useStyles();

  return (
    <div
      className={classes.aspectRatioBox}
      style={{
        backgroundImage: 'linear-gradient(45deg,var(--gradient-red-start),var(--gradient-red-end))',
      }}
    >
      <div className={classes.aspectRatioBoxInside}>
        <div className={classes.fireboxCentering}>
          <div className={classes.viewPortSizing}>{props.children}</div>
        </div>
      </div>
    </div>
  );
}

interface CompetitionSliderSlider {
  setTitle: any;
}

function CompetitionSlider({ setTitle }: CompetitionSliderSlider) {
  const classes = useStyles();

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));
  const prevRef = useRef<HTMLDivElement>(null);
  const nextRef = useRef<HTMLDivElement>(null);

  const [citizenArray, setCitizenArray] = useState<any>(null);

  // const { data, loading, error } = useQuery(GET_CITIZEN_MENU, {
  //   variables: {
  //     limit: 5,
  //     sort: "created_at:DESC",
  //   },
  // });

  // useEffect(() => {
  //   console.log(data)
  //   if (data && data.citizenJoyPrograms) {
  //     setCitizenArray(data.citizenJoyPrograms);
  //   }
  //   return () => {
  //     setCitizenArray(null);
  //   };
  // }, [data]);
  // if (loading) return null;
  // if (data === undefined) return null;
  // if (error || data.citizenJoyPrograms) {
  //   console.log(error);
  // }

  const { data, loading, error } = useQuery(GET_CITIZEN_IMAGES, {
    // pollInterval: 2000,
    fetchPolicy: 'no-cache',
    variables: {
      limit: 5,
      // sort: "id:DESC",
      sort: 'created_at:DESC',
    },
  });

  useEffect(() => {
    if (data && data.citizenJoyImages) {
      setCitizenArray(data.citizenJoyImages);
    }
    return () => {
      setCitizenArray(null);
    };
  }, [data]);
  if (loading) return null;
  if (data === undefined) return null;
  if (error || !data.citizenJoyImages) {
    console.log(error);
  }

  return (
    <Grid xs={12} item style={{ height: '85%' }}>
      {citizenArray && citizenArray.length > 0 ? (
        <Swiper
          id="webtoon-slider"
          tag="section"
          wrapperTag="div"
          navigation={{
            prevEl: prevRef.current!, // Assert non-null
            nextEl: nextRef.current!, // Assert non-null
          }}
          // pagination={{ clickable: true }}
          // spaceBetween={0}
          // slidesPerView={1}
          // scrollbar={{ draggable: true }}
          onInit={(swiper) => {
            if (citizenArray) {
              setTitle(citizenArray[swiper.activeIndex].title);
            }
            // setTitle(state[swiper.activeIndex].title);
          }}
          onSlideChange={(swiper) => {
            setTitle(citizenArray[swiper.activeIndex].title);

            // setTitle(state[swiper.activeIndex].title);
          }}
          // onReachEnd={() => console.log("Swiper end Reached")}
          // onSwiper={(swiper) => console.log(swiper)}
          style={{ height: '100%', overflowX: 'hidden' }}
        >
          {/* {slides} */}

          {citizenArray.map((element: any, index: any) => {
            return (
              <SwiperSlide key={`citizenjoy-slide-${index}`} tag="div">
                <Link to={`citizen-joy/${element.citizen_joy_program.id}`}>
                  <img src={`${element.feat_img.url}`} alt={element.title} style={{ width: '100%' }} />
                </Link>
              </SwiperSlide>
            );
          })}
          <div
            ref={prevRef}
            style={{
              position: 'absolute',
              top: !matches ? 180 : 52,
              left: !matches ? 24 : 0,
              zIndex: 1,
            }}
          >
            <IconButton>
              <ArrowBackIosIcon fontSize={'large'} style={{ color: '#bc243c' }} />
            </IconButton>
          </div>
          <div
            ref={nextRef}
            style={{
              position: 'absolute',
              top: !matches ? 180 : 52,
              right: !matches ? 24 : 0,
              zIndex: 1,
            }}
          >
            <IconButton>
              <ArrowForwardIosIcon fontSize={'large'} style={{ color: '#bc243c' }} />
            </IconButton>
          </div>
        </Swiper>
      ) : (
        <div></div>
      )}
    </Grid>
  );
}

export default CompetitionSlider;
